import React, { Component } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButtonView from "presentational/common/IconButtonView";
import PropTypes from "prop-types";

class ClearAdornmentButtonView extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { onClick } = this.props;

    return (
      <InputAdornment position="end">
        <IconButtonView
          type={"close"}
          disableRightMargin
          onClick={onClick}
          buttonSize={"small"}
          fontSize={"small"}
        />
      </InputAdornment>
    );
  }
}

export default ClearAdornmentButtonView;
